import apiClient from './client'

export interface CSATResult {
  csatId: string
  sessionId: string
  rating: number
  comment: string | null
}

export async function submitCSAT(
  sessionId: string,
  rating: number,
  comment?: string,
): Promise<CSATResult> {
  const { data } = await apiClient.post<{
    csat_id: string
    session_id: string
    rating: number
    comment: string | null
  }>(`/sessions/${sessionId}/csat`, { rating, comment: comment ?? null })
  return { csatId: data.csat_id, sessionId: data.session_id, rating: data.rating, comment: data.comment }
}

export async function getCSAT(sessionId: string): Promise<CSATResult | null> {
  const { data } = await apiClient.get<{
    csat_id?: string
    session_id: string
    rating: number | null
    comment: string | null
  }>(`/sessions/${sessionId}/csat`)
  if (data.rating === null) return null
  return { csatId: data.csat_id ?? '', sessionId: data.session_id, rating: data.rating, comment: data.comment }
}
